import { render, staticRenderFns } from "./InactiveUserList.vue?vue&type=template&id=89f5b8d4"
import script from "./InactiveUserList.vue?vue&type=script&lang=js"
export * from "./InactiveUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports